module.exports = __webpack_public_path__ + "static/sir-salon-opportunity-ce65f8a379f363276c6c5d27bad141cf.jpg";